
import { FC } from 'react';

export const TRUE_FALSE = [{ key: 'true', label: 'Yes' }, { key: 'false', label: 'No' }];

export interface IBooleanRadioProps {
  onChange: (value: boolean) => void;
  name: string;
  value?: boolean;
  error?: string;
  readOnly?: boolean;
  labels?: { trueLabel: string; falseLabel: string };
}

export const BooleanRadio: FC<IBooleanRadioProps> = ({ onChange, value, error, name, readOnly, labels  }) => {
  
  // use custom labels if provided, otherwise default
  const displayLabels = labels || { trueLabel: 'Yes', falseLabel: 'No' };

  const options = [
    { key: 'true', label: displayLabels.trueLabel },
    { key: 'false', label: displayLabels.falseLabel }
  ];

  return <div className='cb-radio-custom'>{options.map((option) => {
    return <label key={`${name}-${option.key}-boolean-radio`}>
      <input disabled={readOnly} className='cb-radio-style' type='radio' checked={`${value}` === option.key ? true : false} onChange={() => { onChange(option.key === 'true' ? true : false); }}></input> {option.label}
    </label>;
  })}
    {error &&
      <span style={{ marginTop: '2px', marginBottom: '8px' }} className='cb-input-helper cb-validation-error'>{error}</span>
    }
  </div>;
};